<!--
    描述：审计任务首页
    时间：2021-03-29
    Created by 王帅
    Edit by zl
-->
<template>
	<div class="Task-layout primary-layout filter-layout">
		<div class="filter-box mb30">
			<el-row :gutter="15"
					v-show="searchToggle">
				<el-form ref="elForm"
						 :model="formData"
						 size="small"
						 label-width="120px">
					<el-col :span="6">
						<el-form-item :label="activeName != '1' ? '委托单号' : '审计任务编号'"
									  :prop="activeName != '1' ? 'orderNo' : 'acceptNo'">
							<el-input v-model="formData.orderNo"
									  placeholder="请输入委托单号"
									  v-if="activeName != '1'"></el-input>
							<el-input v-model="formData.acceptNo"
									  placeholder="请输入审计任务编号"
									  v-else></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="委托单位"
									  prop="sponsorUnit">
							<el-input v-model="formData.sponsorUnit"
									  placeholder="请输入委托单位名称（全称或简称）"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="委托单位类型"
									  prop="entrustType">
							<el-select v-model="formData.entrustType"
									   placeholder="请选择委托单位类型">
								<el-option label="建设单位"
										   value="0"></el-option>
								<el-option label="审计单位"
										   value="1"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="审计任务类型"
									  prop="auditType">
							<el-select v-model="formData.auditType"
									   placeholder="请选择审计任务类型">
								<el-option v-for="(item, index) in projectDict.sjrwlx"
										   :key="'auditType' + index"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="工程项目名称"
									  prop="proName">
							<el-input v-model="formData.proName"
									  placeholder="请输入工程项目名称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="项目类型"
									  prop="proType">
							<el-select v-model="formData.proType"
									   placeholder="请选择项目类型">
								<el-option v-for="(item, index) in projectDict.xmlx"
										   :key="'proType' + index"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="6">
						<el-form-item label="标段编号"
									  prop="packNo">
							<el-input v-model="formData.packNo"
									  placeholder="请输入标段编号"></el-input>
						</el-form-item>
					</el-col> -->
					<el-col :span="6">
						<el-form-item label="标段名称"
									  prop="packName">
							<el-input v-model="formData.packName"
									  placeholder="请输入标段名称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6"
							v-if="activeName != '1'">
						<el-form-item label="委托日期"
									  prop="dateTime">
							<el-date-picker type="daterange"
											v-model="formData.dateTime"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											@change="dealDate($event,'wt')"
											clearable></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6"
							v-if="activeName == '1'">
						<el-form-item label="受理日期"
									  prop="dealTime">
							<el-date-picker type="daterange"
											v-model="formData.dealTime"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											@change="dealDate($event,'sl')"
											clearable></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24"
							style="padding: 0">
						<el-col :span="6"
								v-if="activeName == '1'">
							<el-form-item label="协审单位负责人"
										  prop="assistantTaskPrincipal">
								<el-input v-model="formData.assistantTaskPrincipal"
										  placeholder="请输入协审单位负责人"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12"
								v-if="activeName == '1'">
							<el-form-item label="标签选择"
										  prop="tagIds">
								<el-select v-model="formData.tagIds"
										   placeholder="请选择标签"
										   popper-class="tag-box"
										   multiple
										   :popper-append-to-body="false">
									<el-option v-for="(item, index) in tagList"
											   :key="'tagList' + index"
											   :label="item.sname"
											   :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="activeName != '1' ? 24 : 6">
							<el-form-item class="text-right">
								<el-button type="primary"
										   icon="el-icon-search"
										   @click="searchForm">查询</el-button>
								<el-button @click="resetForm"
										   icon="el-icon-refresh">重置</el-button>
							</el-form-item>
						</el-col>
					</el-col>
				</el-form>
			</el-row>

			<!-- 筛选折叠按钮 -->
			<div class="control-btn"
				 @click="searchToggle = !searchToggle">
				{{ searchToggle ? '点击收起' : '筛选' }}
				<svg-icon :icon-class="searchToggle ? 'pack-up' : 'pack-down'"
						  class="c-icon ml5"></svg-icon>
			</div>
		</div>
		<div class="primary-content">
			<div class="primary-header mb5">
				<div class="left-tabs">
					<el-tabs v-model="activeName"
							 @tab-click="tabClick">
						<el-tab-pane label="待受理"
									 name="0"></el-tab-pane>
						<el-tab-pane label="已受理"
									 name="1"></el-tab-pane>
						<el-tab-pane label="退审"
									 name="2"></el-tab-pane>
					</el-tabs>
				</div>
				<div class="btnGroups">
					<el-button v-if="activeName=='1'"
							   size="small"
							   class="btn-blue"
							   @click.native="showTagsDialog('add')">+添加标签</el-button>
					<el-button size="small"
							   icon="el-icon-menu"
							   class="btn-blue"
							   @click="doFilter">列过滤</el-button>
					<!--					 <el-button size="small"
							   @click="exportExcel">导出Excel</el-button>-->
				</div>
			</div>
			<div class="primary-contanier"
				 v-loading="loading">
				<CustomTableVxe v-if="tableShow"
								ref="filterTable"
								:requestConfigUrl="CustomTableVxeData.requestConfigUrl"
								:requestDataUrl="CustomTableVxeData.requestDataUrl"
								:btnEvent="CustomTableVxeData.btnEvent"
								:config="CustomTableVxeData.table.config"
								:data="CustomTableVxeData.table.data"
								:page="CustomTableVxeData.table.page"
								@page-change="pageListen"
								@current-change="onRowClick"
								:class="{'xTable-tags-task': this.activeName == '1' && !topStyle }">
					<template slot="审计任务编号"
							  slot-scope="scope">
						<span class="vxe-cell--label">{{ scope.row.acceptNo }}</span>
						<el-tooltip :content="`标签：${scope.row.tags}`"
									placement="right"
									effect="light"
									v-if="scope.row.tags && scope.row.tags !== ''">
							<div slot="content"
								 class="label-tooltip">
								<el-tag class="mr10 mb10"
										size="mini"
										v-for="(item, index) in toArray(
                                                scope.row.tags
                                            )"
										:key="index">{{ item }}</el-tag>
							</div>
							<svg-icon icon-class="biaoqian"
									  :class="{ topSet: getSectionStatus(scope.row.status) == '' }"
									  class="biaoqian"></svg-icon>
						</el-tooltip>
						<template v-if="getSectionStatus(scope.row.status) !== ''">
							<el-tooltip :disabled="scope.row.reason == ''"
										effect="light"
										placement="right">
								<div slot="content"
									 class="label-tooltip tooltipWidth">
									{{ scope.row.reason }}
								</div>
								<svg-icon class="section-icon"
										  :class="{ topSet: !scope.row.tags }"
										  :icon-class="getSectionStatus(scope.row.status)"></svg-icon>
							</el-tooltip>
						</template>
					</template>
					<div slot="委托单位"
						 slot-scope="scope">
						<el-tooltip effect="dark"
									:content="scope.row.sponsorUnit"
									placement="top">
							<span class="vxe-cell--label">{{ scope.row.sponsorUnitShortName }}</span>
						</el-tooltip>
					</div>
					<div slot="委托对象"
						 slot-scope="scope">
						<el-tooltip effect="dark"
									:content="scope.row.tenantName"
									placement="top">
							<span class="vxe-cell--label">{{ scope.row.tenantNameShortName }}</span>
						</el-tooltip>
					</div>
					<div slot="委托日期"
						 slot-scope="scope">
						<el-tooltip effect="dark"
									:content="scope.row.taskEntrustDate"
									placement="top">
							<span class="vxe-cell--label">{{ scope.row.taskEntrustDate.substr(0, 11) }}</span>
						</el-tooltip>
					</div>
					<div slot="受理日期"
						 slot-scope="scope">
						<el-tooltip effect="dark"
									:content="scope.row.taskAcceptDate"
									placement="top">
							<span class="vxe-cell--label">{{ scope.row.taskAcceptDate.substr(0, 11) }}</span>
						</el-tooltip>
					</div>
					<template slot="委托单位类型"
							  slot-scope="scope">
						<span class="vxe-cell--label"
							  v-if="scope.row.entrustType == 0">建设单位</span>
						<span class="vxe-cell--label"
							  v-else-if="scope.row.entrustType == 1">审计单位</span>
						<span class="vxe-cell--label"
							  v-else>-</span>
					</template>
					<div slot="建设单位"
						 slot-scope="scope">
						<el-tooltip effect="dark"
									:content="scope.row.ownerUnitName"
									placement="top">
							<span class="vxe-cell--label">{{ scope.row.ownerUnitShortName }}</span>
						</el-tooltip>
					</div>
					<!-- 状态 -->
					<template slot="当前状态"
							  slot-scope="scope">
						<span :class="dealClass(scope.row.status)">
							{{ scope.row.statusName }}
						</span>
					</template>
					<!-- 置顶 -->
					<div slot="置顶"
						 slot-scope="scope">
						<svg-icon icon-class="zhiding"
								  class="zd-class"
								  v-if="!scope.row.sort"
								  @click="handleMove('1', scope.row)"></svg-icon>
						<el-dropdown @command="handleMove($event, scope.row)"
									 size="small"
									 placement="bottom-end"
									 v-if="scope.row.sort"
									 class="el-drop-reset">
							<svg-icon icon-class="yizhiding"
									  class="yzd-class"></svg-icon>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="2">取消置顶</el-dropdown-item>
								<el-dropdown-item command="3"
												  :disabled="scope.row.sort && scope.row.sort === 1">上移
								</el-dropdown-item>
								<el-dropdown-item command="4"
												  :disabled="scope.row.sort === maxSort">下移
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</CustomTableVxe>
			</div>
		</div>

		<!-- 弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.show"
				   :width="dialogObj.width"
				   append-to-body
				   :close-on-click-modal="false"
				   center
				   @close="doCancel">
			<AuditDialog v-if="dialogObj.show"
						 ref="auditDialog"
						 :dialogType="dialogObj.type"
						 :dataObj="selectObj"
						 :onlyshow="onlyshow"></AuditDialog>
			<div slot="footer">
				<el-button class="btn"
						   @click="doCancel">取 消</el-button>
				<el-button class="btn"
						   type="primary"
						   :loading="btnLoading"
						   v-if="dialogObj.type != 'details'"
						   @click="doSubmit(dialogObj.type)">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 标签 -->
		<AddLabelDialog :isShowDialog="tagsDialog.visible"
						:curRowId="curRowId"
						:curRowName="curRowName"
						@close-dialogStatus="close_dialog"
						:dialogData="dialogData"
						tagFor="taskIndex"></AddLabelDialog>

		<!-- 列过滤弹窗 -->
		<ColumnFilter v-if="showFilter"
					  ref="filterColumn"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import ConfigJson from './config.json'
import AuditDialog from '@/views/AuditManage/AuditDialog'
import AddLabelDialog from '@/views/Common/AddLabelDialog'
import ColumnFilter from '@/views/Common/ColumnFilter'
import { getAuditWorkPower } from 'api/home/homeIndex'
import * as API from 'api/audit/audit'
import { mapState } from 'vuex'
import { getStatusStyle } from 'utils/tools.js'
import axios from 'axios'
import { getItem, setItem } from 'utils/storage'
export default {
	name: 'TakIndex',
	components: { AuditDialog, AddLabelDialog, ColumnFilter },
	data() {
		return {
			activeName: '0',
			formData: {
				orderNo: '', //委托单号
				acceptNo: '', //审计任务编号
				sponsorUnit: '', //委托单位
				dateTime: [], //委托日期
				startDate: '', //委托开始时间
				endDate: '', //委托结束时间"
				dealTime: [], //受理日期
				acceptStartDate: '', //受理开始时间
				acceptEndDate: '', //受理结束时间
				auditType: '', //审计任务类型
				proName: '', //工程项目名称
				proType: '', //项目类型
				packNo: '', //标段编号
				packName: '', //标段名称
				assistantTaskPrincipal: '', //协审单位负责人
				current: 1,
				size: 10,
				status: '1001026009', //状态
				sign: '1',
				tenantId: '',
				modularSign: '2',
				entrustType: '',
				tagIds: '',
			},
			searchToggle: true, //筛选
			tableShow: true, //表格显示
			CustomTableVxeData: {
				requestConfigUrl: '',
				requestDataUrl: '',
				btnEvent: [],
				table: {
					config: {},
					page: {
						currentPage: 1,
						pageSize: 10,
						total: 20,
					},
					data: [],
				},
			},
			// 弹窗
			dialogObj: {
				title: '',
				show: false,
				type: '',
				width: '1000px',
			},
			selectObj: {}, //点击选中的数据
			loading: false, // 加载
			curRowId: '', // 当前行数据的id
			curRowName: '', //当前行项目名称
			tagsDialog: {
				visible: false,
				width: '800px',
				title: '添加标签',
				type: '',
				module: 'tag',
			},
			dialogData: {},
			tagList: [],
			btnLoading: false,
			maxSort: 0,
			// 列过滤对象数组
			showFilter: false,
			filterColumns: [
				{
					title: '待受理',
					checkAll: false,
					columns: [],
				},
				{
					title: '已受理',
					checkAll: false,
					columns: [],
				},
			],
			onlyshow: false,
			topStyle: false,
		}
	},
	created() {
		this.getSortNum()
		this.CustomTableVxeData.btnEvent = this.accpetBtns
		this.CustomTableVxeData.table.config =
			ConfigJson.auditTask.project_to_accept
		this.formData.tenantId = this.tenantId
		this.getAllTags()
		if (this.$getSessionItem('contractPrice')) {
			let name = this.$getSessionItem('contractPrice')
			this.$removeSessionItem('contractPrice')
			ConfigJson.auditTask.project_accepted.column.map((x) => {
				if (x.field == name) {
					x.visible = true
				}
			})
		}
		if (this.$getSessionItem('settlementAuditPrice')) {
			let name = this.$getSessionItem('settlementAuditPrice')
			this.$removeSessionItem('settlementAuditPrice')
			ConfigJson.auditTask.project_accepted.column.map((x) => {
				if (x.field == name) {
					x.visible = true
				}
			})
		}
		if (this.$getSessionItem('completedOutputValue')) {
			let name = this.$getSessionItem('completedOutputValue')
			this.$removeSessionItem('completedOutputValue')
			ConfigJson.auditTask.project_accepted.column.map((x) => {
				if (x.field == name) {
					x.visible = true
				}
			})
		}
		if (this.$getSessionItem('activeName')) {
			this.activeName = JSON.parse(this.$getSessionItem('activeName'))
			this.$removeSessionItem('activeName')
			let data = {
				name: this.activeName,
			}
			this.tabClick(data)
		} else {
			this.getData()
		}

		// 列过滤对象数组
		this.$set(
			this.filterColumns[0],
			'columns',
			ConfigJson.auditTask.project_to_accept.column
		)
		this.$set(
			this.filterColumns[1],
			'columns',
			ConfigJson.auditTask.project_accepted.column
		)
		this.filterCheck(this.filterColumns[1])
	},
	methods: {
		// 获取列表数据
		getData() {
			let params = Object.assign({}, this.formData)
			if (params.tagIds.length > 0) {
				params.tagIds = params.tagIds.join(',')
			} else {
				params.tagIds = ''
			}
			let xTable = this.CustomTableVxeData.table
			this.loading = true
			this.tableShow = false
			API.selectBusTaskAll(params)
				.then((res) => {
					if (this.formData.size != -1) {
						xTable.page.total = parseInt(res.data.total)
					} else {
						xTable.page.total = parseInt(res.data.records.length)
					}
					setTimeout(() => {
						xTable.data = res.data.records
						this.loading = false
						this.tableShow = true
					}, 50)
				})
				.catch(() => {
					xTable.data = []
					xTable.page.total = 0
					this.tableShow = true
					this.loading = false
				})
		},

		// 搜索
		searchForm() {
			this.formData.current = 1
			this.CustomTableVxeData.table.page.currentPage = 1
			this.getData()
		},

		// 重置
		resetForm() {
			this.$refs.elForm.resetFields()
			this.formData.startDate = ''
			this.formData.endDate = ''
			this.formData.acceptStartDate = ''
			this.formData.acceptEndDate = ''
			this.searchForm()
		},

		// 导出excel
		exportExcel() {
			let params = Object.assign({}, this.formData)
			if (params.tagIds.length > 0) {
				params.tagIds = params.tagIds.join(',')
			} else {
				params.tagIds = ''
			}
			var index = this.activeName
			//符合设定 序号不参与列过滤
			var arr = [
				{
					name: '序号',
					field: 'seq',
					isCheck: true,
				},
			]
			//退审的没有列过滤
			if (this.activeName != 2) {
				//获取列过滤的数据
				var fileds = this.filterColumns[index].columns
				//组装后台需要的数据格式
				fileds
					.filter((f) => f.field != 'sort')
					.forEach((f) => {
						arr.push({
							name: f.title,
							field: f.field,
							isCheck: f.visible,
						})
					})
				//这里是控制是否根据列过滤导出 0 不是 1 是
				params.isAllExport = '1'
				params.exportExcleHeader = arr
			}
			axios
				.post(
					process.env.VUE_APP_BASE_URL + 'busTask/busTaskInfoExcel',
					params,
					{
						responseType: 'arraybuffer',
						headers: {
							tenantId: getItem('tenantId') || '',
							token: getItem('token') || '',
							limitId: getItem('limitId') || '',
						},
					}
				)
				.then((res) => {
					// 获取文件名  这里是后台使用了cache-control 放文件名称  Content-Disposition  axios不接受
					const fileName = decodeURI(
						res.headers['cache-control'].split('=')[1]
					)
					const link = document.createElement('a') // 创建元素
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel',
					})
					link.style.display = 'none'
					link.href = URL.createObjectURL(blob) // 创建下载的链接
					//num++
					link.setAttribute('download', fileName) // 给下载后的文件命名
					document.body.appendChild(link)
					link.click() // 点击下载
					document.body.removeChild(link) //  下载完成移除元素
					window.URL.revokeObjectURL(link.href) // 释放掉blob对象
				})
		},

		// --------------标签相关
		// 行点击事件
		onRowClick(obj) {
			this.curRowId = obj.row.id
			this.curRowName = obj.row.proName
		},

		// 展示标签
		toArray(str) {
			let arr = str ? str.split(',').filter((x) => x !== '') : []
			return arr
		},

		// 展示标签弹窗
		showTagsDialog(type) {
			if (this.curRowId === '') {
				this.$message.warning('请先选择要添加标签的项目！')
				return
			}

			switch (type) {
				case 'add':
					// 新增
					let params = {
						objectId: this.curRowId,
						applys: '1001025003003',
						busUnit: '1001025003',
					}

					API.getObjectTags(params)
						.then((res) => {
							// 已选择标签
							this.originalTags = JSON.parse(
								JSON.stringify(res.data.privateExsitTags)
							)
							this.selectedTags = res.data.privateExsitTags

							// // 公共标签
							// this.publicTags = res.data.platTags;

							// // 个人历史标签
							// this.personalTags = res.data.privateTags;

							// 所有标签集合
							this.allTags = [
								...res.data.platTags,
								...res.data.privateTags,
							]
							this.dialogData = {
								originalTags: this.originalTags,
								selectedTags: this.selectedTags,
								publicTags: this.publicTags,
								personalTags: this.personalTags,
								allTags: this.allTags,
							}
						})
						.catch((err) => {})
					break
				case 'view':
					break
			}
			this.tagsDialog.visible = true
			this.tagsDialog.type = type
		},

		close_dialog(val) {
			this.tagsDialog.visible = false
			this.curRowId = ''
			if (!val) {
				this.getData()
				this.getAllTags()
			}
		},

		// 分页监听
		pageListen(obj) {
			this.formData.current = obj.currentPage
			this.formData.size = obj.pageSize
			this.getData()
		},

		// 点击
		doClick(data, type, title) {
			this.dialogObj.show = true
			this.dialogObj.type = type
			this.dialogObj.title = title
			this.selectObj = data
			if (type == 'view') {
				// 储存当前菜单
				let obj = {
					meta: this.$route.meta,
					path: this.$route.path,
					name: this.$route.name,
				}
				this.$setSessionItem('activeMenu', JSON.stringify(obj))
				this.$setSessionItem('currentRow', JSON.stringify(data))
				this.$setSessionItem(
					'activeName',
					JSON.stringify(this.activeName)
				)
				this.dialogObj.show = false
				let queryParams = {
					menu: 'auditTask',
					active: this.activeName,
					type: 'view',
					projectId: data.projectId,
				}
				this.$router.push({
					name: 'AuditLook',
					query: queryParams,
				})
			}
		},

		// 弹框取消
		doCancel() {
			this.dialogObj.title = ''
			this.dialogObj.type = ''
			this.dialogObj.show = false
			this.onlyshow = false
		},

		// 弹框确认
		doSubmit(type) {
			switch (type) {
				case 'deal':
					this.toAccept()
					break
				case 'del':
					this.comeBack()
					break
				case 'addPerson':
					this.addPersonInCharge()
					break
				case 'editPerson':
					this.addPersonInCharge()
					break
				case 'details':
					this.doCancel()
					break
			}
		},

		// tabClick
		tabClick(data) {
			let name = data.name
			this.tableShow = false
			this.curRowId = ''
			let xTable = this.CustomTableVxeData
			this.formData.size = 10
			xTable.table.page.pageSize = 10
			if (name == '0') {
				this.dateClear(name)
				this.formData.acceptNo = ''
				this.formData.acceptStartDate = ''
				this.formData.acceptEndDate = ''
				this.formData.assistantTaskPrincipal = ''
				this.formData.status = '1001026009'
				xTable.table.config = ConfigJson.auditTask.project_to_accept
				xTable.btnEvent = this.accpetBtns
			} else if (name == '1') {
				this.dateClear(name)
				this.formData.orderNo = ''
				this.formData.startDate = ''
				this.formData.endDate = ''
				this.formData.status = null
				xTable.table.config = ConfigJson.auditTask.project_accepted
				xTable.btnEvent = this.accpetedBtns
			} else if (name == '2') {
				this.dateClear(name)
				this.formData.acceptNo = ''
				this.formData.acceptStartDate = ''
				this.formData.acceptEndDate = ''
				this.formData.status = '1001026007'
				this.formData.assistantTaskPrincipal = ''
				this.formData.unitSign = 1
				xTable.table.config = ConfigJson.auditTask.project_come_back
				xTable.btnEvent = this.backBtns
			}
			setTimeout(() => {
				this.tableShow = true
				this.searchForm()
			}, 100)
		},

		// 处理时间
		dealDate(data, type) {
			if (type == 'wt') {
				// 委托日期
				this.formData.startDate = data[0]
				this.formData.endDate = data[1]
			} else {
				// 处理日期
				this.formData.acceptStartDate = data[0]
				this.formData.acceptEndDate = data[1]
			}
		},

		// 处理时间 切换tabs时触发
		dateClear(type) {
			if (type == '1') {
				this.formData.startDate = ''
				this.formData.endDate = ''
				this.formData.dateTime = []
			} else {
				this.formData.acceptStartDate = ''
				this.formData.acceptEndDate = ''
				this.formData.dealTime = []
			}
		},

		// 任务受理
		toAccept() {
			this.btnLoading = true
			API.taskAcceptance({
				id: this.selectObj.id,
				unitId: this.tenantId, //受理单位
				source: '2', //1、审计管理受理  2、协审任务受理
			})
				.then((res) => {
					if (res.operationCode != 1 || res.msg == 'faild') {
						this.btnLoading = false
						this.$message.error(res.data)
						return
					}
					this.dialogObj.show = false
					setTimeout(() => {
						this.doClick(
							this.selectObj,
							'addPerson',
							'添加协审单位项目负责人'
						)
						this.btnLoading = false
						this.onlyshow = true
						let data = {
							name: '1',
						}
						this.activeName = '1'
						this.tabClick(data)
					}, 200)
				})
				.catch(() => {
					this.btnLoading = false
				})
		},

		// 退审
		comeBack() {
			let obj = this.$refs.auditDialog
			this.btnLoading = true
			if (obj.comeBackReason != '') {
				API.taskWithdrawal({
					id: this.selectObj.id,
					remark: obj.comeBackReason, //退审理由
					source: '2', //1、审计管理退审  2、协审任务退审
				})
					.then((res) => {
						if (res.operationCode != 1 || res.msg == 'faild') {
							this.btnLoading = false
							this.$message.error(res.data)
							return
						}
						this.getData()
						this.dialogObj.show = false
						this.btnLoading = false
					})
					.catch(() => {
						this.btnLoading = false
					})
			} else {
				this.$message.error('请填写原因！')
				this.btnLoading = false
			}
		},

		// 添加负责人
		addPersonInCharge() {
			let obj = this.$refs.auditDialog
			obj.$refs.addForm.validate((valid) => {
				if (valid) {
					this.btnLoading = true
					API.addPersonInCharge({
						id: this.selectObj.id,
						taskPrincipal: obj.addForm.taskPrincipal, //单位负责人
						oldTaskPrincipal: obj.addForm.oldTaskPrincipal, //更换之前的单位负责人，可以为空
						constract: obj.addForm.constract, //负责人联系电话
						description: obj.addForm.description, //负责人职位描述
						source: '2',
						type: this.dialogObj.type == 'addPerson' ? '1' : '2', // 1 新增 2 编辑
					})
						.then((res) => {
							this.getData()
							this.dialogObj.show = false
							this.btnLoading = false
						})
						.catch(() => {
							this.btnLoading = false
						})
				}
			})
			return
		},

		// 处理状态
		dealStatus(data) {
			let msg = ''
			switch (data) {
				case 0:
					msg = '待受理'
					break
				case 1:
					msg = '已受理'
					break
				case 2:
					msg = '已退审'
					break
				case 3:
					msg = '内部审核通过(已开始作业）'
					break
				case 4:
					msg = '内部审核被驳回'
					break
				case 5:
					msg = '已归档'
					break
				case 6:
					msg = '已结项'
					break
			}
			return msg
		},

		// 获取标段报审状态 及 原因
		getSectionStatus(status) {
			let icon = ''
			// 0：未提交报审;  1：已提交报审;  2：报审内部审核通过; 3：提交报审被驳回; 4：撤回; 5：提交报审被退回; 6：已受理
			switch (status) {
				case '1001026003':
					icon = 'section-refuse'
					break
				case '1001026004':
					icon = 'section-cancel'
					break
				case '1001026012':
					icon = 'section-return'
					break
				default:
					icon = ''
			}

			return icon
		},

		// 获取所有标签
		getAllTags() {
			API.selectTagListForBox({
				applys: '1001025003003',
				busUnit: '1001025003',
			}).then((res) => {
				this.tagList = res.data
			})
		},

		// 获取置顶总数
		getSortNum() {
			API.getSortSum({
				modularSign: '2',
			}).then((res) => {
				this.maxSort = res.data
			})
		},

		// 表格内 置顶功能---------------------
		handleMove(val, row) {
			// loading
			this.loading = true

			if (val === '1' && row.sort === 1) {
				this.loading = false
				this.$message.warning('已经是置顶第一条数据!')
				return
			}

			let params = {
				modularSign: '2',
				signType: val, // 置顶:top，取消置顶:cancel,置顶上移:up 置顶下移： down
				subtaskId: row.subtaskId, // 项目ID
			}
			API.topOperation(params)
				.then((res) => {
					this.$message.success(res.msg)
					this.getSortNum()
					this.loading = false
					this.formData.current = 1
					this.CustomTableVxeData.table.page.currentPage = 1
					this.tabClick({ name: '1' })
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 点击列过滤
		doFilter() {
			this.showFilter = true
			setTimeout(() => {
				this.$refs.filterColumn.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			if (this.$refs.filterTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)

				this.$refs.filterTable.refreshColumn()
				this.filterCheck(this.filterColumns[1])
				this.getData()
			}
		},

		// 处理样式
		dealClass(data) {
			let msg = getStatusStyle(data)
			return msg
		},

		// 判断第二列是不是 置顶
		filterCheck(data) {
			let arr = data.columns.filter((x) => x.visible == true)
			if (arr) {
				this.topStyle =
					arr[0].field == 'taskPrincipalName' ? true : false
			}
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
		...mapState('user', {
			tenantId: (state) => state.tenantId,
		}),
		accpetBtns() {
			let btns = [
				{
					name: '查看',
					icon: '',
					renderIcon: 'form-look',
					disabled: (data) => {
						return false
					},
					show: (data) => {
						return this.roleBtns.includes('view')
					},
					click: (data) => {
						this.doClick(data, 'view', '查看')
					},
				},
				{
					name: '受理',
					icon: '',
					renderIcon: 'form-shouli',
					disabled: (data) => {
						return false
					},
					show: (data) => {
						return this.roleBtns.includes('dealWith')
					},
					click: (data) => {
						this.doClick(data, 'deal', '受理')
					},
				},
				{
					name: '退审',
					icon: '',
					renderIcon: 'form-tuishen',
					disabled: (data) => {
						return false
					},
					show: (data) => {
						return this.roleBtns.includes('recall')
					},
					click: (data) => {
						this.doClick(data, 'del', '退审')
					},
				},
			]
			return btns
		},
		accpetedBtns() {
			let btns = [
				{
					name: '查看',
					icon: '',
					renderIcon: 'form-look',
					disabled: (data) => {
						return false
					},
					show: (data) => {
						return this.roleBtns.includes('view')
					},
					click: (data) => {
						this.doClick(data, 'view', '查看')
					},
				},
				{
					name: '添加负责人',
					icon: '',
					renderIcon: 'form-add',
					disabled: (data) => {
						// 已受理的可以添加负责人 其余的不行
						return data.status != '1001026010' ? true : false
					},
					show: (data) => {
						if (this.roleBtns.includes('addPerson')) {
							if (!data.taskPrincipalName) {
								return true
							}
						}
						return false
					},
					click: (data) => {
						this.doClick(
							data,
							'addPerson',
							'添加协审单位项目负责人'
						)
					},
				},
				{
					name: '更改负责人',
					icon: '',
					renderIcon: 'form-edit',
					disabled: (data) => {
						// 已受理的可以添加负责人 其余的不行
						return data.status != '1001026010' ? true : false
					},
					show: (data) => {
						if (this.roleBtns.includes('addPerson')) {
							if (
								data.taskPrincipalName &&
								data.taskPrincipalName != ''
							) {
								return true
							}
						}
						return false
					},
					click: (data) => {
						this.doClick(
							data,
							'editPerson',
							'更改协审单位项目负责人'
						)
					},
				},
				{
					name: '进入项目',
					icon: '',
					renderIcon: 'form-enter',
					disabled: (data) => {
						return false
					},
					show: (data) => {
						return this.roleBtns.includes('getInItem')
					},
					click: (data) => {
						let url = this.$outUrl
						let token = this.$getSessionItem('token')
						let tenantId = this.$getSessionItem('tenantId')
						let limitId = this.$getSessionItem('limitId')
						getAuditWorkPower({
							projectId: data.projectId,
						}).then((res) => {
							if (res.data.constructor == String) {
								this.$message.warning(res.data)
							} else {
								window.open(
									`${url}/DxAuditWork/#/main?projectId=${data.projectId}&token=${token}&tenantId=${tenantId==null?'':tenantId}&limitId=${limitId==null?'':limitId}&isDataRole=${res.data}`,
									'_blank'
								)
							}
						})
					},
				},
				{
					name: '退审',
					icon: '',
					renderIcon: 'form-tuishen',
					disabled: (data) => {
						// 已结项的 禁用按钮
						let arr =
							'1001026008,1001026013,1001026022,1001026023,1001026025,1001026026,1001026027,1001026028'
						return arr.includes(data.status)
					},
					show: (data) => {
						return this.roleBtns.includes('recall')
					},
					click: (data) => {
						this.doClick(data, 'del', '退审')
					},
				},
			]
			return btns
		},
		backBtns() {
			let btns = [
				{
					name: '详情',
					icon: '',
					renderIcon: 'form-detail',
					disabled: (data) => {
						return false
					},
					show: (data) => {
						return this.roleBtns.includes('details')
					},
					click: (data) => {
						this.doClick(data, 'details', '详情')
					},
				},
			]
			return btns
		},
	},
}
</script>

<style scoped lang="less">
.Task-layout {
	padding: 30px 20px 5px 20px;
	.filter-box {
		padding-bottom: 15px;
	}
	.primary-contanier {
		height: calc(~'100% - 40px');
	}
	.section-icon {
		color: #ca0a14;
		margin-right: 3px;
		font-size: 16px;
		vertical-align: sub;
	}
}
.zd-class {
	position: absolute;
	width: 100px;
	height: 65px;
	color: #2671cc;
	cursor: pointer;
	transform: translate(-50%, -44%);
}
.yzd-class {
	position: absolute;
	width: 100px;
	height: 80px;
	color: #72aa2c;
	cursor: pointer;
	transform: translate(-50%, 0%);
}
.el-drop-reset {
	width: 118px !important;
	height: 20px !important;
}
.btn {
	padding: 0 50px !important;
}
.xTable-tags-task {
	/deep/.vxe-table--body {
		tbody > tr > td:nth-child(2) {
			.vxe-cell {
				padding-left: 25px !important;
				position: relative;
				overflow: unset;
				.biaoqian {
					position: absolute;
					z-index: 10;
					left: 5px;
					top: 15px;
				}
				.section-icon {
					position: absolute;
					top: -5px;
					left: 5px;
				}
				.topSet {
					top: 5px;
				}
			}
		}
	}
}
</style>
